import React, { useState, useEffect } from 'react';
import ReactTable from '../../components/reactTable';
import { fetchInspections } from '../../services/ReportService'; // Import the service
import { FaView, FaEdit } from '../../components/FontIcons';
import AddDrainReports from '../../components/addDrainReport';

const OnsiteReport = () => {
  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);


  const [columnDefs] = useState([
    { field: 'InspectionId', headerName: 'Inspection ID', sortable: true, filter: true, flex: 1 },
    { field: 'location', headerName: 'Location', sortable: true, filter: true, flex: 1 },
    { field: 'pincode', headerName: 'Pincode', sortable: true, filter: true, flex: 1 },
    { field: 'datetime', headerName: 'Date & Time', sortable: true, filter: true, flex: 1 },
    // { field: 'photo', headerName: 'Photo', sortable: true, filter: true, flex: 1 },
    // { field: 'userName', headerName: 'User Name', sortable: true, filter: true, flex: 1 },
    // { field: 'userEmail', headerName: 'User Email', sortable: true, filter: true, flex: 1 },
    { field: 'inspectionType', headerName: 'Inspection Type', sortable: true, filter: true, flex: 1 },
    {
      headerName: 'Actions',
      field: 'actions',
      flex: 1,
      sortable: false,
      cellRenderer: (params) => (
        <>
          <span onClick={() => handleEdit(params.data)}><FaEdit size="lg" className="add-edit-button" /></span>
          <FaView size="lg" className="view-button" />
        </>
      ),
    },
  ]);

  const handleEdit = (rowData) => {
    console.log('Edit button clicked for row:', rowData);
    setShowModal(true);
  };



  useEffect(() => {
    const getInspections = async () => {
      try {
        const data = await fetchInspections();
        setRowData(data);
      } catch (err) {
        setError('Failed to fetch inspections');
      } finally {
        setLoading(false);
      }
    };
    getInspections();
  }, []); // Effect runs once after the component mounts


  // Function to hide the modal
  const handleCloseModal = () => {
    setShowModal(false);
  };



  return (
    <div className="container-fluid pt-4 px-4">
      <div className="row g-4">
        <div className="padding-4">
          <h3>Onsite Report Table</h3>
          {loading && <p>Loading...</p>}
          {error && <p>{error}</p>}
          <ReactTable rowData={rowData} columnDefs={columnDefs} />
        </div>
      </div>

      <AddDrainReports showModal={showModal}
        handleCloseModal={handleCloseModal} />
    </div>
  );
};

export default OnsiteReport;
